import React from 'react';
import Modal from '../ui/Modal';
import './DirectorModal.css';

/*
 * Thin adapter around the design-system <Modal> primitive.
 * Preserves the existing DirectorModal API (title / badge / onClose /
 * children) so all 15+ consumers continue to work unchanged. The badge
 * eyebrow is composed into the modal title via JSX; everything else
 * (surface, focus trap, escape handling, ARIA wiring, close button)
 * comes from the primitive.
 */
function DirectorModal({ title, badge = '', onClose, children, className = '' }) {
  const compositeTitle = badge ? (
    <>
      <span className="director-modal-eyebrow">{badge}</span>
      {title}
    </>
  ) : title;

  return (
    <Modal
      open
      size="lg"
      title={compositeTitle}
      onClose={onClose}
      className={['director-modal', className].filter(Boolean).join(' ')}
    >
      {children}
    </Modal>
  );
}

export default DirectorModal;
